import {
  EmailAccountWidgetItem,
  Widget,
  WidgetContentItemsList,
} from '../../Widget'

import { getMyUnreadEmailsItemProps } from './MyUnreadEmailsWidget.utils'

function MyUnreadEmailsWidget({
  Item = EmailAccountWidgetItem,
  getItemPropsFromValue = getMyUnreadEmailsItemProps,
  isSkeleton,
  items,
  widgetContentItemsProps,
  widgetProps,
}) {
  return (
    <Widget
      {...widgetProps}
      headerProps={{
        contentProps: {
          actionsProps: {
            EditButton: null,
          },
        },
      }}
      isSkeleton={isSkeleton}
    >
      <WidgetContentItemsList
        {...widgetContentItemsProps}
        Item={Item}
        getItemPropsFromValue={getItemPropsFromValue}
        items={items}
      />
    </Widget>
  )
}

export default MyUnreadEmailsWidget
